import { useEffect, useState } from "react";
import { Select } from "chakra-react-select";
import { searchClients } from "services";
import { useController } from "react-hook-form";

const ClientSelect = ({ control, name, rules, isMulti, defaultValue }) => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    name,
    control,
    rules,
  });

  const getClients = async () => {
    const res = await searchClients({
      page_num: page,
      per_page: 1000,
      contact: searchText,
    });
    const users = res.data.users;
    users.sort((a, b) => a.contact.localeCompare(b.contact));
    setClients(users);
  };

  useEffect(() => {
    setPage(0);
    getClients();
  }, [searchText]);

  useEffect(() => {
    getClients();
  }, []);

  // Initialize selectedClient with defaultValue
  // useEffect(() => {
  //   if (defaultValue && clients.length > 0) {
  //     const client = clients.find(c => c._id === defaultValue);
  //     if (client) {
  //       setSelectedClient({
  //         label: `${client.contact} (${client.email})`,
  //         value: client._id
  //       });
  //     }
  //   }
  // }, [defaultValue, clients]);

  // Update selected client when value changes
  useEffect(() => {
    if (value) {
      const client = clients.find(c => c._id === value);
      if (client) {
        setSelectedClient({
          label: `${client.contact} (${client.email})`,
          value: client._id
        });
      }
    } else {
      setSelectedClient(null);
    }
  }, [value, clients]);

  const options =
    (clients.length > 0 &&
      clients.map((client) => ({
        label: `${client.contact} (${client.email})`,
        value: client._id,
      }))) ||
    [];

  return (
    <Select
      value={selectedClient}
      onInputChange={(ev) => {
        setSearchText(ev);
      }}
      placeholder="Select Client"
      onBlur={onBlur}
      options={options}
      onChange={(ev) => {
        setSelectedClient(ev);
        onChange(ev?.value || null);
      }}
      onMenuScrollToBottom={() => {
        setPage(page + 1);
      }}
    />
  );
};

export default ClientSelect;
